import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '~core/core.module';
import { ExportAppMetadata } from '../models/export-app-metadata.model';

@Component({
  selector: 'ait-upload-metadata',
  templateUrl: './upload-metadata.component.html',
  styleUrls: ['./upload-metadata.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadMetadataComponent implements OnInit {
  selectedFile: File;

  constructor(
    private _dialogRef: MatDialogRef<UploadMetadataComponent>,
    private readonly _notificationService: NotificationService
  ) {}

  ngOnInit() {}

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.readAsText(this.selectedFile, 'UTF-8');
    fileReader.onload = () => {
      try {
        const data = JSON.parse(fileReader.result as string);
        const appMetadata = ExportAppMetadata.adapt(data);
        this._dialogRef.close(appMetadata);
      } catch (error) {
        this._notificationService.error(
          'Error parsing file, JSON file expected'
        );
      }
    };
    fileReader.onerror = error => {
      this._notificationService.error('Error reading file');
    };
  }
}
